module.exports = __webpack_public_path__ + "fontawesome-webfont.af7ae505a9eed503f8b8.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/EZepeda/Desktop/Explora/adminexplora/~/font-awesome/fonts/fontawesome-webfont.woff2?v=4.7.0
// module id = ../../../../font-awesome/fonts/fontawesome-webfont.woff2?v=4.7.0
// module chunks = 2